<template>
   <div class="center">
      <h1>Error: 404</h1>
      <h2>Page not found</h2>
   </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.center {
   h1 {
      font-size: 6em;
   }
   font-family: $primary-font;
   color: $font-color;
   text-align: center;
   display: flex;
   flex-direction: column;
   margin-top: 30vh;
   height: 100vh;
}
</style>